const LocationsHistoric = () => <div>historial locations</div>

export default LocationsHistoric
